import { useState } from "react";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { NationalLawViewModel } from "./NationalLaws.types";

import { useDotLegalQuery, useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";

export function useNationalLawsDataMapping() {
    const queryClient = useDotLegalQueryClient();
    const [showAllNationalLaws, setShowAllNationalLaws] = useStateLocalStorage("onlyActiveNationalLaws", false);
    const [showNationalLawDialog, setShowNationalLawDialog] = useState(false);
    const [showDeleteNationalLawDialog, setShowDeleteNationalLawDialog] = useState(false);
    const [showChangeNationalLawStatusDialog, setShowChangeNationalLawStatusDialog] = useState(false);
    const [selectedNationalLaw, setSelectedNationalLaw] = useState<NationalLawViewModel | undefined>(undefined);

    const queryPart = `?showAllNationalLaws=${showAllNationalLaws}`;
    const url = `/nationalLaws${queryPart}`;
    let { isLoading, data } = useDotLegalQuery<Array<NationalLawViewModel>>(url);

    const OnSave = () => {
        queryClient.refetchQueries(url);
    };

    return {
        isLoading,
        data,
        OnSave,
        showAllNationalLaws,
        setShowAllNationalLaws,
        showNationalLawDialog,
        setShowNationalLawDialog,
        showDeleteNationalLawDialog,
        setShowDeleteNationalLawDialog,
        showChangeNationalLawStatusDialog,
        setShowChangeNationalLawStatusDialog,
        selectedNationalLaw,
        setSelectedNationalLaw,
    };
}
